<template>
  <search-nav @handleSearch="handleSearch">
    <search-nav-item-field label="키워드" v-model="keyword" @keyupEvent="handleInput" />
    <search-nav-item-select label="종별" v-model="bri_type" :list="typeOptions" name="bri_type" />
  </search-nav>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavItemField from "@/components/nav/SearchNavItemField.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";

export default {
  name: "Search",
  components: {SearchNavItemSelect, SearchNavItemField, SearchNav},
  data() {
    return {
      keyword: '',
      bri_type: '',
    }
  },
  computed: {
    typeOptions() {
      return [
        {text: '전체', value: ''},
        {text: '1종', value: '1종'},
        {text: '2종', value: '2종'},
        {text: '3종', value: '3종'},
        {text: '기타', value: '기타'},
      ]
    }
  },
  methods: {
    // "검색" 버튼이 클릭됐을 때
    handleSearch() {
      this.$emit("search", {
        keyword: this.keyword,
        bri_type: this.bri_type,
      })
    },
    handleInput() {
      //this.handleSearch()
    },
  },
}
</script>

<style scoped>

</style>
